import { css } from 'lit';

var css_248z = css`:host{--heatmap-number-scale-color:#9c9da5;--heatmap-text-color:var(--textNeutralStrong);--color-range-start:#d7191c;--color-range-mid:#ffffbf;--color-range-end:#1a9641;display:block}svg{height:auto;width:100%}.label{text-anchor:middle;font-size:12px}.axis line,.axis path{display:none}`;

export { css_248z as default };
//# sourceMappingURL=heatMapChart.styles.css.js.map
